@if (files.length > 0) {
  <div class="flex-vertical width-100pc">
    <oui-accordion buttonPosition="title-end" [expanded]="files.length > 0" [disabled]="files.length < 1">
      <oui-accordion-header>
        @if(withValidateAll && backofficeEditable()) {
          <oui-accordion-actions>
            <oui-button (click)="onValidateAllClick()" [disabled]="!canBatchValidate">Tout valider</oui-button>
          </oui-accordion-actions>
        }
        <oui-accordion-title [ngClass]="titleClass">{{ title }} ({{ files.length }})</oui-accordion-title>
      </oui-accordion-header>
      <lib-operation-files-list
        class="files-list"
        [audience]="audience"
        [checkbox]="checkbox"
        [files]="files"
      (fileClicked)="onfileClick($event)"></lib-operation-files-list>
    </oui-accordion>
  </div>
}
